'use client';

import { FC } from 'react';

export interface InputProps {
    id?: string;
    name: string;
    disabled?: boolean;
    size?: 'small' | 'medium' | 'large';
    placeholder?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value: string;
    testId: string;
    type?: string;
    extendedClassName?: string;
    error?: boolean;
    maxLength?: number;
    required?: boolean;
}

const Input: FC<InputProps> = (props) => {
    const { name = '', disabled = false, extendedClassName = '', size = 'small', error = false, type = 'text' } = props;

    const borderClassNames = `border rounded focus:outline-none`;
    const focusClassNames = `focus:outline-none focus:border-[#86b7fe] focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.08),0_0_8px_rgba(102,175,233,0.6)]`;
    const textClassNames = `text-[100%] placeholder:text-[100%] text-gray-900 font-normal`;
    const bgClassNames = `bg-white bg-clip-padding`;
    const defaultClassName = `input px-[12px] py-[6px] block leading-6`;

    // Error
    let errorClassName = '';
    if (error) {
        errorClassName =
            'input-error focus:border-red-500 focus:shadow-[inset_0_1px_1px_rgba(0,0,0,0.08),0_0_8px_rgba(255,99,71,0.6)]';
    }

    let disabledClass = '';
    if (disabled) {
        disabledClass =
            'disabled:!border-custom-gray-06 disabled:bg-custom-gray-07 disabled:text-custom-black-01 disabled:opacity-100';
    }

    // Sizes
    let sizeClassName = 'input-sm';
    if (size === 'medium') {
        sizeClassName = 'input-md';
    } else if (size === 'large') {
        sizeClassName = 'input-lg';
    }

    const inputClassNames = [
        borderClassNames,
        focusClassNames,
        textClassNames,
        bgClassNames,
        defaultClassName,
        sizeClassName,
        errorClassName,
        extendedClassName,
        disabledClass,
    ];

    return (
        <input
            id={props.id}
            name={name}
            type={type}
            className={inputClassNames.join(' ')}
            disabled={disabled}
            placeholder={props.placeholder}
            data-test-id={props.testId}
            onChange={props.onChange}
            value={props.value}
            maxLength={props.maxLength}
            required={props.required}
        />
    );
};

export default Input;
